/**
 * Transcript module for audio player
 * Simplified version - only language links, no rendering
 */

// Import submodules
import * as lectureUtils from './transcript/lecture-utils.js';
import * as loader from './transcript/loader.js';
import * as container from './transcript/container.js';
import * as languages from './transcript/languages.js';
import {
	setCurrentLanguage,
	setAvailableLanguages,
	resetState,
	clearContainerElements
} from './transcript/state.js';
import { hideTranscriptContainer } from './transcript/container.js';

// Re-export public API
export const isAudioLecture = lectureUtils.isAudioLecture;
export const extractLectureName = lectureUtils.extractLectureName;
export const extractLectureId = lectureUtils.extractLectureId;
export const initTranscriptContainer = container.initTranscriptContainer;

/**
 * Load and display language links for a lecture
 * @param {string} lectureName - Lecture name (full filename without extension)
 * @param {string} language - Language code (default: 'en', not used but kept for compatibility)
 */
export async function loadAndDisplayTranscript(lectureName, language = 'en') {
	if (!lectureName) {
		hideTranscriptContainer();
		return;
	}
	
	// Load available languages
	const langs = await loader.getAvailableLanguages(lectureName);
	setAvailableLanguages(langs);
	
	if (langs.length === 0) {
		hideTranscriptContainer();
		return;
	}
	
	// Set first available language as current (for compatibility)
	if (langs.includes(language)) {
		setCurrentLanguage(language);
	} else {
		setCurrentLanguage(langs[0]);
	}
	
	// Show container and render language links
	container.showTranscriptContainer();
	languages.renderLanguageButtons(lectureName);
}

/**
 * Clear transcript
 */
export function clearTranscript() {
	resetState();
	clearContainerElements();
	hideTranscriptContainer();
}
